export function parseDateTimeSlot(date, timeSlot) {
    const to24Hour = timeStr => {
        const [time, modifier] = timeStr.trim().split(' ');
        let [hours, minutes] = time.split(':');
        if (modifier === 'PM' && hours !== '12') {
            hours = String(parseInt(hours) + 12);
        }
        if (modifier === 'AM' && hours === '12') {
            hours = '00';
        }
        return `${hours.padStart(2, '0')}:${minutes}`;
    };

    const [startTime, endTime] = timeSlot.split('-');

    const start = `${date} ${to24Hour(startTime)}`;
    const end = `${date} ${to24Hour(endTime)}`;

    return { start, end };
}

export const customGlobalFilter = (rows, columnIds, filterValue) => {
    return rows.filter(row => {
        const rowData = row.original;
        // Iterate over all fields in row.original to check for a match
        for (const key in rowData) {
            if (
                rowData[key] &&
                rowData[key]
                    .toString()
                    .toLowerCase()
                    .includes(filterValue.toLowerCase())
            ) {
                return true; // If any field matches, keep this row
            }
        }
        return false; // Otherwise, filter it out
    });
};
export const getInitials = (name = "") => {
    const words = name?.trim().split(" ");
    if (words?.length === 1) return words[0][0]?.toUpperCase() || "";
    return (words[0][0] + words[1][0]).toUpperCase();
};